<template>    
    <v-combobox 
    :loading="loading" 
    :items="items" 
    solo 
    :value="value" 
    @input="$emit('input', $event)"></v-combobox>      
</template>
<script>
import axios from 'axios'
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ["value"],
    data: function () {
        return {
            loading: true,
            items: [],
            search: null,
            select: null
        }
    },
    created: function() {
        this.query();
    },
    methods: {
        query() {
            axios.get(`/api/divisionsSearch/parliamentarians`)
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                });
        }
    }
}
</script>